import React from 'react'
import { ReactComponent as FavouriteIcon } from '../../assets/icons/favorite.svg'
import { ReactComponent as FavouritedIcon } from '../../assets/icons/favorited.svg'

const FavoriteIcon = ({ isLiked }) => {
    return isLiked ? <FavouritedIcon /> : <FavouriteIcon />
}

export default FavoriteIcon
